import * as API from '../api'
export const READING_TIME_FETCH = 'READING_TIME_FETCH'
export const READING_TIME_FETCHING = 'READING_TIME_FETCHING'
export const READING_TIME_FETCH_ERROR = 'READING_TIME_FETCH_ERROR'
export const READING_TIME_OPEN_MODAL = 'READING_TIME_OPEN_MODAL'
export const READING_TIME_CLOSE_MODAL = 'READING_TIME_CLOSE_MODAL'
export const READING_TIME_CHANGE = 'READING_TIME_CHANGE'
export const READING_TIME_DELETE = 'READING_TIME_DELETE'
export const READING_TIME_ADD = 'READING_TIME_ADD'
export const READING_TIME_EDIT = 'READING_TIME_EDIT'
export const READING_TIME_FORM_TOUCHED = 'READING_TIME_FORM_TOUCHED'
export const READING_TIME_NEW_FORM = 'READING_TIME_NEW_FORM'
export const READING_TIME_FORM_ERROR = 'READING_TIME_FORM_ERROR'
export const READING_TIME_CHANGE_PAGE = 'READING_TIME_CHANGE_PAGE'
export const READING_TIME_CHANGE_PER_PAGE = 'READING_TIME_CHANGE_PER_PAGE'
export const READING_TIME_CHANGE_ORDER_COLUMN = 'READING_TIME_CHANGE_ORDER_COLUMN'
export const READING_TIME_CHANGE_ORDER_DIRECTION = 'READING_TIME_CHANGE_ORDER_DIRECTION'
export const READING_TIME_RESET_STATE = 'READING_TIME_RESET_STATE'
export const READING_TIME_FETCH_RANGES = 'READING_TIME_FETCH_RANGES'
export const READING_TIME_FETCHING_RANGES = 'READING_TIME_FETCHING_RANGES'
export const READING_TIME_FETCH_RANGES_ERROR = 'READING_TIME_FETCH_RANGES_ERROR'
export const READING_TIMES_FETCH = 'READING_TIMES_FETCH'
export const READING_TIMES_FETCH_ALL = 'READING_TIMES_FETCH_ALL'
export const READING_TIMES_FETCHING = 'READING_TIMES_FETCHING'
export const READING_TIMES_FETCH_ERROR = 'READING_TIMES_FETCH_ERROR'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: READING_TIME_OPEN_MODAL })
  }
}

export const handleChange = readingTime => {
  return dispatch => {
    dispatch({ type: READING_TIME_CHANGE, readingTime })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

export const handleError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  if (typeof errorMessage === 'object') return

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: READING_TIME_FORM_TOUCHED
      })
      dispatch({
        type: READING_TIME_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${getDuplicateKeyField(errorMessage)} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newForm = () => {
  return dispatch => {
    dispatch({ type: READING_TIME_NEW_FORM })
  }
}

export const setFormTouched = () => {
  return dispatch => {
    dispatch({ type: READING_TIME_FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: READING_TIME_CLOSE_MODAL })
  }
}

export const restore = id => {
  return dispatch => {
    dispatch({ type: READING_TIMES_FETCHING })
    return API.readingTimes
      .restore(id)
      .then(({ data }) => {
        dispatch({ type: READING_TIME_EDIT, readingTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: READING_TIMES_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: READING_TIME_CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: READING_TIME_CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: READING_TIME_CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: READING_TIME_CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: READING_TIME_RESET_STATE })
  }
}

export const fetchAll = () => {
  return dispatch => {
    API.readingTimes.fetchAll().then((res = {}) => {
      const { data } = res
      dispatch({ type: READING_TIMES_FETCH_ALL, readingTime: data })
    })
  }
}

export const index = options => {
  return dispatch => {
    dispatch({ type: READING_TIMES_FETCHING })
    return API.readingTimes
      .index(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: READING_TIMES_FETCH,
          items: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: READING_TIMES_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const remove = id => {
  return dispatch => {
    dispatch({ type: READING_TIMES_FETCHING })
    return API.readingTimes
      .remove(id)
      .then(({ data: readingTime }) => {
        dispatch({ type: READING_TIME_DELETE, readingTime })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: READING_TIMES_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const add = readingTime => {
  return dispatch => {
    dispatch({ type: READING_TIMES_FETCHING })
    dispatch({ type: READING_TIME_FETCHING })
    return API.readingTimes
      .create(readingTime)
      .then(({ data }) => {
        dispatch({ type: READING_TIME_ADD, readingTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleError(response, dispatch)
        dispatch({
          type: READING_TIMES_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const edit = readingTime => {
  return dispatch => {
    dispatch({ type: READING_TIMES_FETCHING })
    dispatch({ type: READING_TIME_FETCHING })
    return API.readingTimes
      .update(readingTime)
      .then(({ data }) => {
        dispatch({ type: READING_TIME_EDIT, readingTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: READING_TIMES_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetch = id => {
  return dispatch => {
    dispatch({ type: READING_TIME_FETCHING, clear: true })
    dispatch({ type: READING_TIME_OPEN_MODAL })
    return API.readingTimes
      .fetch(id)
      .then(({ data }) => {
        dispatch({ type: READING_TIME_FETCH, readingTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: READING_TIME_FETCH_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const fetchRanges = () => dispatch => {
  dispatch({ type: READING_TIME_FETCHING_RANGES })
  return API.readingTimes
    .ranges()
    .then(({ data: { ranges = [] } }) =>
      dispatch({ type: READING_TIME_FETCH_RANGES, ranges: ranges || [] })
    )
    .catch(err => {
      const { response = {} } = err
      const { data = {} } = response
      const { message } = data
      dispatch({
        type: READING_TIME_FETCH_RANGES_ERROR,
        err: message || 'Serviço indisponível'
      })
      return Promise.reject(err)
    })
}



// WEBPACK FOOTER //
// ./src/actions/readingTime.js